// Interface for the Google Maps Javascript API
// see documentation at  https://developers.google.com/maps/documentation/javascript/tutorial
//
// Specifically using the following libraries:
// - places              https://developers.google.com/maps/documentation/javascript/places
// - places autocomplete https://developers.google.com/maps/documentation/javascript/places-autocomplete
// - geocodeing          https://developers.google.com/maps/documentation/javascript/geocoding
// - geometry            https://developers.google.com/maps/documentation/javascript/geometry




// At the moment, I can only include the Google Maps Javascript API library as
// an external resource via <script> tag in `index.html`, so it's in the global
// scope for now...

const google = window.google
const dummyNode = document.createElement('div')
const autocompleteService = new google.maps.places.AutocompleteService()
const placesService = new google.maps.places.PlacesService(dummyNode)
const geocoder = new google.maps.Geocoder()
// const placesService = new google.maps.places.PlacesService(dummyNode)
const LatLng = google.maps.LatLng




// Temporary fake user location for search result biasing
// (will be removed when app state includes user location)
const loc = new LatLng(43.677598, -70.230592)





// =============================
// = GoogleMaps utility object =
// =============================

const GoogleMaps = {}

GoogleMaps.LatLng = LatLng

// Place query status types
GoogleMaps.PlacesServiceStatus = google.maps.places.PlacesServiceStatus

// Get autocomplete region place results
GoogleMaps.getRegions = (query, callback) => {
  const request = {
    input: query,
    types: ['(regions)'],
    location: loc,
    radius: 5000,
    componentRestrictions: { country: ['us'] }
  }
  autocompleteService.getPlacePredictions(request, callback)
}

// Get natural features
GoogleMaps.getNaturalFeatures = (query, callback) => {
  const request = {
    query: query,
    location: loc,
    radius: 5000,
  }

  placesService.textSearch(request, (response, responseStatus) => {
    let filteredResponse = null

    if (responseStatus === GoogleMaps.PlacesServiceStatus.OK)
        filteredResponse = response.filter(place => {
          return place.types.some(type => type === 'natural_feature')
        })
    else
      filteredResponse = response

    callback.call(null, filteredResponse, responseStatus)
  })
}

// Get geocoded info from a place id
GoogleMaps.geocode = (placeId, callback) => {
  const request = {placeId: placeId}
  geocoder.geocode(request, callback)
}

// Compute distances between two objects
GoogleMaps.computeDistanceBetween = (inputA, inputB) => {
  const a = (inputA instanceof LatLng) ? inputA : new LatLng(inputA)
  const b = (inputB instanceof LatLng) ? inputB : new LatLng(inputB)

  return google.maps.geometry.spherical.computeDistanceBetween(a, b)
}





// ========================
// = log-callback methods =
// ========================

GoogleMaps.logCallback = (method, ...args) => {
  method(...args, (...response) => {
    console.log(...response)
  })
}


export default GoogleMaps
window.GoogleMaps = GoogleMaps




// =========
// = Notes =
// =========


// Library load URL
// <script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBzSx33AT3KQ5aXNOXGL0dsyv5vNvwb5HA&libraries=places,geometry"></script>

// Libraries interested in
// places,geometry

// API key
// AIzaSyBzSx33AT3KQ5aXNOXGL0dsyv5vNvwb5HA


// Casco Bay, Maine, USA
// ChIJqSmIlMBkrUwRJJZl_9A6x3E



// as = new google.maps.places.AutocompleteService()
// as.getPlacePredictions({input: 'casco', types: ["(regions)"], location: loc, radius: 5000}, (predictions) => {console.log(predictions)})

// g = new google.maps.Geocoder()
// g.geocode({placeId: 'ChIJqSmIlMBkrUwRJJZl_9A6x3E'}, (res, status) => {console.log(status, res)})

// ps = new p.PlacesService(document.createElement('div'))
// ps.getDetails({placeId: 'ChIJqSmIlMBkrUwRJJZl_9A6x3E'}, (res, status) => {console.log(status, res)})




// WEBPACK FOOTER //
// ./src/services/google-maps-api.js